import {
  X,
  Printer,
  Download,
  FileText,
  Calendar,
  User,
  Wallet,
  BadgeIndianRupee,
  Tag,
  Paperclip,
} from "lucide-react";

export default function ExpenseDetailsModal({ expense, onClose }) {
  if (!expense) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-6">
      <div className="w-full max-w-5xl rounded-2xl bg-[#0b0b0f] border border-white/10 overflow-hidden">

        {/* Header */}

        <div className="flex justify-between items-center px-8 py-6 border-b border-white/10">
          <div>
            <h2 className="text-2xl font-serif">Expense Details</h2>

            <p className="text-xs text-gray-400 mt-1">
              {expense.expense_no}
            </p>
          </div>

          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-white/10"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}

        <div className="p-8 space-y-8">

          {/* Amount */}

          <div className="rounded-2xl bg-gradient-to-r from-amber-400/10 to-yellow-500/5 border border-amber-400/20 p-6">

            <p className="text-xs uppercase tracking-widest text-gray-400">
              Expense Amount
            </p>

            <h2 className="mt-3 text-4xl font-serif text-amber-400">
              ₹{Number(expense.amount).toLocaleString("en-IN")}
            </h2>

          </div>

          {/* Information */}

          <div className="grid md:grid-cols-2 gap-5">

            <InfoCard
              icon={Calendar}
              title="Expense Date"
              value={expense.expense_date}
            />

            <InfoCard
              icon={FileText}
              title="Expense Number"
              value={expense.expense_no}
            />

            <InfoCard
              icon={Tag}
              title="Category"
              value={expense.category}
            />

            <InfoCard
              icon={User}
              title="Vendor"
              value={expense.vendor_name || "-"}
            />

            <InfoCard
              icon={Wallet}
              title="Payment Mode"
              value={expense.payment_mode}
            />

            <InfoCard
              icon={BadgeIndianRupee}
              title="Reference"
              value={expense.reference || "-"}
            />

          </div>

          {/* Notes */}

          <div className="rounded-2xl bg-white/5 border border-white/10 p-6">

            <h3 className="font-serif text-lg mb-4">
              Notes
            </h3>

            <p className="text-gray-300 leading-7 whitespace-pre-wrap">
              {expense.notes || "No notes available."}
            </p>

          </div>

          {/* Attachment */}

          <div className="rounded-2xl bg-white/5 border border-white/10 p-6">

            <h3 className="font-serif text-lg mb-4">
              Attachment
            </h3>

            {expense.attachment ? (
              <a
                href={`/api/uploads/${expense.attachment}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-amber-400 hover:underline"
              >
                <Paperclip size={16} />
                View Attachment
              </a>
            ) : (
              <p className="text-gray-400">
                No attachment uploaded.
              </p>
            )}

          </div>

        </div>

        {/* Footer */}

        <div className="flex justify-end gap-3 px-8 py-5 border-t border-white/10">

          <button className="flex items-center gap-2 px-5 py-3 rounded-xl border border-white/10 hover:bg-white/5">
            <Printer size={16} />
            Print
          </button>

          <button className="flex items-center gap-2 px-5 py-3 rounded-xl border border-white/10 hover:bg-white/5">
            <Download size={16} />
            Download
          </button>

          <button
            onClick={onClose}
            className="px-6 py-3 rounded-xl bg-amber-400 text-black font-semibold"
          >
            Close
          </button>

        </div>

      </div>
    </div>
  );
}

function InfoCard({ icon: Icon, title, value }) {
  return (
    <div className="rounded-xl bg-white/5 border border-white/10 p-5">

      <div className="flex items-center gap-3 mb-4">

        <div className="w-10 h-10 rounded-lg bg-amber-400/10 flex items-center justify-center">
          <Icon size={18} className="text-amber-400" />
        </div>

        <span className="text-xs uppercase tracking-widest text-gray-400">
          {title}
        </span>

      </div>

      <h3 className="text-lg font-medium">
        {value || "-"}
      </h3>

    </div>
  );
}